import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteScreenTitle: {
        id: 'quoteandbind.wizard.views.residential.quoteScreenTitle',
        defaultMessage: 'Quote'
    },
    paymentRequestFailed: {
        id: 'quoteandbind.wizard.views.residential.paymentRequestFailed',
        defaultMessage: 'Missing Required Fields'
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id: 'quoteandbind.wizard.views.residential.sorryYourPaymentCouldNotBeProcessedAtThisTime',
        defaultMessage: 'Please enter the Estimated Replacement Cost and Estimated Actual Cash Value before editing any other fields.',
    },
    documentMessage: {
        id: 'quoteandbind.wizard.views.residential.documentMessage',
        defaultMessage: 'The Quote Summary will be available shortly on the documents.',
    },
    documentConfirmButton: {
        id: 'quoteandbind.wizard.views.residential.Go to Documents',
        defaultMessage: 'Go to Documents',
    },
    documentContinueButton: {
        id: 'quoteandbind.wizard.views.residential.Continue',
        defaultMessage: 'Continue',
    },
    documentErrorMessage: {
        id: 'quoteandbind.wizard.views.residential.The transaction must be quoted to generate print quote summary.',
        defaultMessage: 'The transaction must be quoted to generate print quote summary.',
    },
    documentErrorTitle: {
        id: 'quoteandbind.wizard.views.residential.Transaction Not Quoted',
        defaultMessage: 'Transaction Not Quoted',
    },
    documentCloseButton: {
        id: 'quoteandbind.wizard.views.residential.Close',
        defaultMessage: 'Close',
    },
    cancelQuote: {
        id: 'quoteandbind.wizard.views.residential.Cancel Quote',
        defaultMessage: 'Are you sure you want to exit?',
    },
    cancelMessage: {
        id: 'quoteandbind.wizard.views.residential.Are you sure you want to cancel the new quote?',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    cancelMessageButton: {
        id: 'quoteandbind.wizard.views.residential.Cancel',
        defaultMessage: 'Cancel',
    },
    cancelMessageYesButton: {
        id: 'quoteandbind.wizard.views.residential.Yes',
        defaultMessage: 'Yes',
    },
    continueLabel: {
        id: 'quoteandbind.wizard.views.residential.continueLabel',
        defaultMessage: 'Continue'
    },
    noCoveragesSelected: {
        id: 'quoteandbind.wizard.views.residential.noCoveragesSelected',
        defaultMessage: 'Please select at least one coverage.'
    }
});
